import React from 'react'
import { useStyles } from './Styles'
import { FormattedMessage } from 'react-intl'
import Badge from '@material-ui/core/Badge'
import NotificationsOutlinedIcon from '@material-ui/icons/NotificationsOutlined'
import { NavLink } from 'react-router-dom'
import { NamedRoutes } from '../../routes'

const HeaderNotification = ({ isMobile }) => {
  const classes = useStyles()
  const mobileClass = isMobile ? classes.notificationMobile : ''
  return (
    <NavLink to={NamedRoutes.notifications} className={classes.notificationButton + ' ' + mobileClass}>
      <Badge badgeContent={0} max={99} color="error"
             anchorOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}>
        <NotificationsOutlinedIcon/>
      </Badge>
      <FormattedMessage id='header.Notifications'/>
    </NavLink>
  )
}

export default HeaderNotification
